// eslint-disable-next-line import/prefer-default-export
export const validateBreakRuleSetConditions = (conditions) =>
    conditions?.every((x) => x.condition !== null && x.shiftDuration && x.action !== null && x.duration);
